import { render } from "./CancellationFlow.vue?vue&type=template&id=0e37f34b"
import script from "./CancellationFlow.vue?vue&type=script&lang=js"
export * from "./CancellationFlow.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./CancellationFlow.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_7745ee6d%2Fpackages%2Fcustomer%2Fsrc%2Fcomponents%2Fcancellation%2FCancellationFlow.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__